// DropdownCheckbox.jsx
import React, { useState, useEffect, useRef } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { ChevronDownSvg } from "../../../svgFiles/ChevronDownSvg";
import { Form } from "react-bootstrap";

const DropdownCheckbox = ({
  label = "Select Option",
  options = [],
  onSelect,
  onClear,
  selectedValues,
  loading = false,
  autoCloseAfterLoad = false,
}) => {
  const isControlled = selectedValues !== undefined;
  const [internalSelected, setInternalSelected] = useState(selectedValues ?? []);
  const [show, setShow] = useState(false);
  const pendingCloseRef = useRef(false);
  const selected = isControlled ? selectedValues : internalSelected;

  useEffect(() => {
    if (!isControlled && selectedValues !== undefined) {
      setInternalSelected(selectedValues);
    }
  }, [isControlled, selectedValues]);

  useEffect(() => {
    if (!autoCloseAfterLoad || !pendingCloseRef.current || loading) {
      return;
    }
    setShow(false);
    pendingCloseRef.current = false;
  }, [loading, autoCloseAfterLoad]);

  const markPendingClose = () => {
    if (autoCloseAfterLoad) {
      pendingCloseRef.current = true;
    }
  };

  const handleSelect = (value) => {
    let updatedSelection;
    if (selected.includes(value)) {
      updatedSelection = selected.filter((v) => v !== value);
    } else {
      updatedSelection = [...selected, value];
    }

    if (!isControlled) {
      setInternalSelected(updatedSelection);
    }
    markPendingClose();
    onSelect?.(updatedSelection);
  };

  const handleClear = () => {
    if (!isControlled) {
      setInternalSelected([]);
    }
    markPendingClose();
    onSelect?.([]);
    onClear?.();
  };

  const displayLabel =
    selected.length === 0
      ? label
      : `${label}: ${selected
          .map((val) => options.find((opt) => opt.value === val)?.label ?? val)
          .join(", ")}`;

  return (
    <Dropdown
      className="custoom-dropdown"
      show={show}
      onToggle={(nextShow) => setShow(nextShow)}
    >
      <Dropdown.Toggle
        id="custom-dropdown"
        variant="unset"
        className="d-flex justify-content-between align-items-center w-100"
      >
        <span className="flex-grow-1 text-start">{displayLabel}</span>
        <ChevronDownSvg />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {options.map((opt) => (
          <div
            className="dropdown-item"
            key={opt.value}
            onClick={(e) => {
              e.preventDefault();
              handleSelect(opt.value);
            }}
            role="menuitem"
          >
            <Form.Check
              type="checkbox"
              checked={selected.includes(opt.value)}
              onChange={(e) => {
                e.stopPropagation();
                handleSelect(opt.value);
              }}
              label={opt.label}
            />
          </div>
        ))}

        <div
          className="dropdown-item fw-medium"
          onClick={(e) => {
            e.preventDefault();
            handleClear();
          }}
          role="menuitem"
        >
          Clear
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DropdownCheckbox;
